<template>
  <div  >
    <Header></Header>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>考生ID:</span>
            <Input v-model="data.userid" placeholder="请输入..." style="width:1.5rem"/>
          </div>
          <div class="item">
            <span>考生姓名:</span>
            <Input v-model="data.name" placeholder="请输入..." style="width:1.5rem"/>
          </div>
          <Button @click="model=true" type="primary" size="small">选择部门/组织</Button>
        </div>
        <div class="search_item">
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
          <div class="item">
            <a class="button" :download="$route.query.id+'考试记录导出.xlsx'" style='display:block' :href="'/api/ExamStatistics/export?examid='+$route.query.id" >导出</a>
          </div>
          <div class="item">
            <div class="button" @click="$router.go(-1)">返回</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>考生ID</td>
              <td>姓名</td>
              <td>部门</td>
              <td>考试名称</td>
              <td>考试得分</td>
              <td>及格状态</td>
              <td>开始时间</td>
              <td>阅卷状态</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.ehuserid}}</td>
              <td>{{item.ehusername}}</td>
              <td>{{item.departmentname}}</td>
              <td>
                <Tooltip :content="item.examtitle" placement="top-start">
                  <span class="tableName">{{item.examtitle}}</span>
                </Tooltip>
              </td>
              <!-- <td>85%</td> -->
              <td>{{item.ehispass==2?'未评分':item.ehscore}}</td>
              <td>{{item.ehispass|ehispass}}</td>
              <td>{{item.ehstartime|formatetime}}</td>
              <td>{{item.ehdecide|yuejuan}}</td>
              <td>
                <button class="pri" @click="topaper(item.ehid,item.ehdecide)">查看解析</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="page" style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          @on-change="changepage"
          :current='data.page'
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div style="height:200px"></div>
    <Modal v-model="model" title="请选择部门或组织">
      <Tree
        style="max-height:400px;overflow-y:auto"
        :data="orglist"
        @on-check-change="checkdata"
        show-checkbox
        multiple
      ></Tree>
      <div slot="footer">
        <Button type="error" size="large" @click="model=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import {
  ExamStatistics_examList,
  Organize_index
} from "../../assets/js/api.js";

export default {
  name: "recordslist",
  data() {
    return {
      list: [],
      model: false,
      orglist: [],
      data: {
        examid: this.$route.query.id,
        // ehexamid:null,//	string	true	普通参数		考试id
        ehid: null, //	string	true	普通参数		考试i记录d
        userid: null, //	string	true	普通参数		用户id
        username: null, //	string	true	普通参数		用户名
        examsid: null, //	string	true	普通参数		部门id
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      total: null
    };
  },
  mounted() {
    this.getlist();
    this.getOrganize();
  },
  filters: {
    ehispass(value){
      return ['不及格','及格','未评分'][value]
    },
    yuejuan(value) {
      switch (value) {
        case 0:
          return "阅卷中";
        case 1:
          return "已阅卷";
        case 2:
          return "无需阅卷";
      }
    }
  },
  components: {
    Header,
    Title
  },
  methods: {
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      ExamStatistics_examList(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });;
      });
    },
    getOrganize() {
      Organize_index().then(res => {
        if (res.data.code == 200) {
          this.orglist = [];
          // 递归遍历 res.data.data
          function rangedata(data) {
            if (data.length > 0) {
              data = data.map(item => {
                var t = {};
                t.expand = false;
                t.orgid = item.orgcode;
                t.title = item.orgname;
                if (item.child) {
                  t.children = rangedata(item.child);
                }
                return t;
              });
              return data;
            } else {
              return;
            }
          }
          this.orglist = rangedata(res.data.data);
        }
      });
    },
    checkdata(data) {
      this.data.examsid = data
        .map(item => {
          return item.orgid;
        })
        .join(",");
    },
    topaper(data, data2) {
      if (data2 == 0) {
        this.$router.push("/Recordexampaper?id=" + data);
      } else {
        this.$router.push("/recordpaper?id=" + data);
      }
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
  justify-content: space-between;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/statistics/recordslist.vue